import { constants, typographyStyles } from "@newsela/angelou";

import { greenWithOpacity } from "@/angelouCE/utils/constants";

const { textSObj } = typographyStyles;

const { colors } = constants;
const green = colors.ui.green[600];
const neutral700 = colors.ui.neutral[700];

export const confirmationMessageCss = {
  display: "flex",
  alignItems: "flex-start",
  backgroundColor: greenWithOpacity,
  color: neutral700,
  padding: "16px",
  borderRadius: "8px",
  ...textSObj,

  p: {
    margin: 0,
  },
};

export const iconContainerCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: green,
  borderRadius: "50%",
  width: "20px",
  height: "20px",
  margin: "2px 8px 2px 0",
  flexShrink: 0,
};

export const checkIconCss = {
  width: 12,
  height: 12,
  path: {
    // This is a one off color to prevent the stroke from blending into thee background
    stroke: "#D4EAE7",
    strokeWidth: "4",
  },
};
